import {errorMessage} from 'shared/actions/notifications';
import UserService from '../../services/UserService';

export const deleteStudent =
  (id: string, reason?: string, redirectPath: string | undefined | false = '/') =>
  async (dispatch) => {
    try {
      await UserService.destroy(id, reason || '');
      if (redirectPath) {
        window.location.href = redirectPath;
      }
    } catch {
      dispatch(errorMessage());
    }
  };
